import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { getMeds, setMedsLoaded } from 'store/storeValtio';
import { updateMedicationInDb } from 'store/localDb';
import HelpTitle from 'components/common/HelpTitle';

export default function SortOrder() {
  const meds = getMeds();
  const [sortedMeds, setSortedMeds] = useState(meds);
  const navigate = useNavigate();

  //console.log('SortOrder', meds, sortedMeds);
  
  function moveUp(e,ix) {
    e.target.blur();
    var sm = [...sortedMeds];
    [sm[ix-1], sm[ix]] = [sm[ix], sm[ix-1]]
    //console.log('up', e);
    setSortedMeds(sm);
  }

  function moveDown(e,ix) {
    var sm = [...sortedMeds];
    [sm[ix+1], sm[ix]] = [sm[ix], sm[ix+1]]
    //console.log('down', sm);
    setSortedMeds(sm);
  }

  function updateSortOrder() {
    //console.log('updateSortOrder', sortedMeds);
    for ( var ix = 0; ix<sortedMeds.length; ++ix) {
        var m = sortedMeds[ix];
        m.sortOrder = ix;
        //console.log(m);
        updateMedicationInDb( m )
    };
    setMedsLoaded(false);
    navigate('/');
  }

  return (
    <div className='w-full h-full pt-10 flex flex-col justify-normal items-center bg-blue-200'>
      <HelpTitle title="Edit Sort Order" subtitle="Move med positon up or down" helpSubject="sortOrder" />
      <div className='mcard w-full'>
        <div className='w-full h-10 flex justify-around text-xl font-semibold'>
          <button className='rawBtn w-4/12 bg-green-400 hover:bg-green-600 mr-2' onClick={() => updateSortOrder()} > Update </button>
          <button className='rawBtn w-4/12 bg-slate-400 hover:bg-slate-600' onClick={() => {navigate(-1)}} > Cancel </button>
        </div>
        <hr />
        <div className='lcard'>
        {sortedMeds.map((m,ix) => {
          //console.log(ix);
          return (
            <div className='flex p-2' key={ix}>
              <div className='w-8/12 text-2xl font-semibold'>
                <h2>{m.name} ({m.sortOrder})</h2>
              </div>
              <div className='w-2/12' >
                { ix > 0 &&
                  <button className='fullBtn bg-blue-400 mr-1'
                      id={`u${ix}`}
                      onClick={(e) => moveUp(e,ix)}
                  >
                  Up
                  </button>
                }
              </div>
              <div className='w-2/12' >
                { ix < sortedMeds.length-1 &&
                  <button className='fullBtn bg-stone-400 ml-1'
                      id={`d${ix}`}
                      onClick={(e) => moveDown(e,ix)}
                  >
                  Down
                  </button>
                }
              </div>
            </div>
          );
        })}
      </div>
    </div>
    </div>
  );
}
